/**
 * Deep equality for plain JSON-like data (what settings forms hold): objects match regardless of key order,
 * arrays match by position, everything else by value. Used to tell whether a form has unsaved changes by
 * comparing what is on screen with the last saved copy.
 */
export function sameData(a, b) {
    if (Object.is(a, b)) return true;
    if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) return false;
    if (Array.isArray(a) !== Array.isArray(b)) return false;
    if (Array.isArray(a)) return a.length === b.length && a.every((v, i) => sameData(v, b[i]));
    const keys = Object.keys(a);
    return keys.length === Object.keys(b).length
        && keys.every((k) => Object.prototype.hasOwnProperty.call(b, k) && sameData(a[k], b[k]));
}
